export default [
  "+247 ####",
  "+290 ####",
  "+290 ####",
  "+683 ####",
  "+690 ####",
  "+500 #####",
  "+676 #####",
  "+677 #####",
  "+678 #####",
  "+688 2####",
  "+49 ### ###",
  "+682 ## ###",
  "+686 ## ###",
  "+688 90####",
  "+95 ### ###",
  "+298 ### ###",
  "+376 ### ###",
  "+387 ## ####",
  "+508 ## ####",
  "+597 ### ###",
  "+672 1## ###",
  "+672 3## ###",
  "+681 ## ####",
  "+685 ## ####",
  "+687 ## ####",
  "+850 ### ###",
  "+230 ### ####",
  "+239 ## #####",
  "+245 # ######",
  "+246 ### ####",
  "+263 # ######",
  "+269 ## #####",
  "+297 ### ####",
  "+299 ## ## ##",
  "+354 ### ####",
  "+372 ### ####",
  "+387 ## #####",
  "+49 ### ## ##",
  "+501 ### ####",
  "+507 ### ####",
  "+592 ### ####",
  "+597 ### ####",
  "+599 ### ####",
  "+599 ### ####",
  "+599 ### ####",
  "+60 # ### ###",
  "+62 ## ### ##",
  "+65 #### ####",
  "+670 ### ####",
  "+673 ### ####",
  "+674 ### ####",
  "+677 ### ####",
  "+678 ## #####",
  "+679 ## #####",
  "+680 ### ####",
  "+689 ## ## ##",
  "+691 ### ####",
  "+692 ### ####",
  "+95 # ### ###",
  "+960 ### ####",
  "+220 ### ## ##",
  "+232 ## ######",
  "+234 ## ### ##",
  "+237 #### ####",
  "+238 ### ## ##",
  "+248 # ### ###",
  "+252 # ### ###",
  "+252 # ### ###",
  "+265 1 ### ###",
  "+291 # ### ###",
  "+350 ### #####",
  "+356 #### ####",
  "+372 #### ####",
  "+373 #### ####",
  "+47 ### ## ###",
  "+49 ### ## ###",
  "+504 #### ####",
  "+505 #### ####",
  "+506 #### ####",
  "+52 ## ## ####",
  "+53 # ### ####",
  "+599 9### ####",
  "+60 ## ### ###",
  "+62 ## ### ###",
  "+64 ## ### ###",
  "+66 ## ### ###",
  "+670 77# #####",
  "+670 78# #####",
  "+850 #### ####",
  "+852 #### ####",
  "+853 #### ####",
  "+886 #### ####",
  "+95 ## ### ###",
  "+961 # ### ###",
  "+965 #### ####",
  "+967 # ### ###",
  "+973 #### ####",
  "+974 #### ####",
  "+975 # ### ###",
  "+1 ### ### ####",
  "+1 242 ### ####",
  "+1 246 ### ####",
  "+1 264 ### ####",
  "+1 268 ### ####",
  "+1 284 ### ####",
  "+1 340 ### ####",
  "+1 345 ### ####",
  "+1 441 ### ####",
  "+1 473 ### ####",
  "+1 649 ### ####",
  "+1 664 ### ####",
  "+1 670 ### ####",
  "+1 671 ### ####",
  "+1 684 ### ####",
  "+1 721 ### ####",
  "+1 758 ### ####",
  "+1 767 ### ####",
  "+1 784 ### ####",
  "+1 809 ### ####",
  "+1 829 ### ####",
  "+1 849 ### ####",
  "+1 868 ### ####",
  "+1 869 ### ####",
  "+1 876 ### ####",
  "+216 ## ### ###",
  "+218 ## ### ###",
  "+222 ## ## ####",
  "+223 ## ## ####",
  "+224 ## ### ###",
  "+225 ## ### ###",
  "+226 ## ## ####",
  "+227 ## ## ####",
  "+228 ## ### ###",
  "+229 ## ## ####",
  "+231 ## ### ###",
  "+234 ## ### ###",
  "+236 ## ## ####",
  "+241 # ## ## ##",
  "+252 ## ### ###",
  "+254 ### ######",
  "+257 ## ## ####",
  "+258 ## ### ###",
  "+262 ##### ####",
  "+262 ##### ####",
  "+266 # ### ####",
  "+267 ## ### ###",
  "+268 ## ## ####",
  "+27 ## ### ####",
  "+31 ## ### ####",
  "+32 ### ### ###",
  "+33 ### ### ###",
  "+34 ### ### ###",
  "+357 ## ### ###",
  "+36 ### ### ###",
  "+370 ### ## ###",
  "+371 ## ### ###",
  "+374 ## ### ###",
  "+377 ## ### ###",
  "+382 ## ### ###",
  "+385 ## ### ###",
  "+386 ## ### ###",
  "+389 ## ### ###",
  "+39 6 698 #####",
  "+40 ## ### ####",
  "+41 ## ### ####",
  "+45 ## ## ## ##",
  "+46 ## ### ####",
  "+48 ### ### ###",
  "+49 ### ## ####",
  "+502 # ### ####",
  "+503 ## ## ####",
  "+509 ## ## ####",
  "+51 ### ### ###",
  "+56 # #### ####",
  "+591 # ### ####",
  "+593 # ### ####",
  "+594 ##### ####",
  "+60 ## ### ####",
  "+60 ### ### ###",
  "+61 # #### ####",
  "+62 ## ### ####",
  "+62 8## ### ###",
  "+64 ### ### ###",
  "+66 ## ### ####",
  "+675 ### ## ###",
  "+81 ### ### ###",
  "+82 ## ### ####",
  "+84 ## #### ###",
  "+850 ## ### ###",
  "+855 ## ### ###",
  "+856 ## ### ###",
  "+880 ## ### ###",
  "+93 ## ### ####",
  "+94 ## ### ####",
  "+961 ## ### ###",
  "+966 # ### ####",
  "+967 ## ### ###",
  "+968 ## ### ###",
  "+971 # ### ####",
  "+972 # ### ####",
  "+975 17 ### ###",
  "+976 ## ## ####",
  "+977 ## ### ###",
  "+993 # ### ####",
  "+20 ### ### ####",
  "+211 ## ### ####",
  "+212 ## #### ###",
  "+213 ## ### ####",
  "+218 21 ### ####",
  "+221 ## ### ####",
  "+233 ### ### ###",
  "+235 ## ## ## ##",
  "+240 ## ### ####",
  "+242 ## ### ####",
  "+243 ### ### ###",
  "+244 ### ### ###",
  "+249 ## ### ####",
  "+250 ### ### ###",
  "+251 ## ### ####",
  "+253 ## ## ## ##",
  "+255 ## ### ####",
  "+256 ### ### ###",
  "+260 ## ### ####",
  "+261 ## ## #####",
  "+264 ## ### ####",
  "+265 # #### ####",
  "+30 ### ### ####",
  "+351 ## ### ####",
  "+352 ### ### ###",
  "+353 ### ### ###",
  "+355 ### ### ###",
  "+359 ### ### ###",
  "+377 ### ### ###",
  "+378 #### ######",
  "+381 ## ### ####",
  "+39 ### #### ###",
  "+420 ### ### ###",
  "+421 ### ### ###",
  "+43 ### ### ####",
  "+44 ## #### ####",
  "+49 ### ### ####",
  "+52 ### ### ####",
  "+54 ### ### ####",
  "+55 ## #### ####",
  "+55 ## 7### ####",
  "+57 ### ### ####",
  "+58 ### ### ####",
  "+590 ### ### ###",
  "+593 ## ### ####",
  "+595 ### ### ###",
  "+598 # ### ## ##",
  "+62 8## ### ####",
  "+63 ### ### ####",
  "+64 ### ### ####",
  "+7 ### ### ## ##",
  "+7 6## ### ## ##",
  "+7 7## ### ## ##",
  "+81 ## #### ####",
  "+84 ### #### ###",
  "+86 ### #### ###",
  "+886 # #### ####",
  "+90 ### ### ####",
  "+91 #### ### ###",
  "+92 ### ### ####",
  "+962 # #### ####",
  "+963 ## #### ###",
  "+966 5 #### ####",
  "+967 ### ### ###",
  "+970 ## ### ####",
  "+971 5# ### ####",
  "+972 5# ### ####",
  "+98 ### ### ####",
  "+992 ## ### ####",
  "+995 ### ### ###",
  "+996 ### ### ###",
  "+998 ## ### ####",
  "+234 ### ### ####",
  "+234 ### ### ####",
  "+375 ## ### ## ##",
  "+380 ## ### ## ##",
  "+423 ### ### ####",
  "+49 #### ### ####",
  "+55 ## 9#### ####",
  "+596 ### ## ## ##",
  "+850 ### #### ###",
  "+850 191 ### ####",
  "+856 20## ### ###",
  "+86 ### #### ####",
  "+964 ### ### ####",
  "+994 ## ### ## ##",
  "+358 ### ### ## ##",
  "+62 8## ### ## ###",
  "+86 ## ##### #####",
  "+850 #### #############"
]
